import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from 'routes/PathLink'
import { Table } from "components/ui/table";
import { Pagination, Select } from "antd";
import { amount_format, cleanCompanyName } from "components/config/Common";

const StockActionTable = (props) => {	
    const {data, pageSize, isLoading, paginatorInfo, totalPages} = props
    //console.log('data props===',data)

    const compactIN = (num) =>
    new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(num);

    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
    id: `sk-${i}`,
    _isSkeleton: true
    }));

    const columns = [
    
    {
      title: 'Stock',
      dataIndex: 'name',
      key: 'name',
      align: 'left',      
      width: 100,
      fixed: 'left',
      className: 'column-bg',
      render:(name,record) =>(
         <div
          className="overflow-hidden truncate whitespace-nowrap text-wrap" >
           {record?.name && record?.name != '' ?
            (<Link title={record?.name} className="text-accent text-wrap" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record.symbol}`}><span className="text-sm">{cleanCompanyName(record?.name)}</span></Link>)
            :(null)
          }          
        </div>
      )
    },
    {
      title: <div className='cursor-pointer' title='Current Market Price'>Price Start <span className="text-xs text-gray-500">Rs</span> </div>,
      dataIndex: 'price_start',
      key: 'price_start',
      align: 'right',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className="flex justify-end">{amount_format(record?.price_start)}</div>
              }
              </>
            )
    },
    
    {
      title: <div className='cursor-pointer' title='Market Capitalization'>Price End <span className="text-xs text-gray-500">Rs</span></div>,
      dataIndex: 'market_cap',
      key: 'market_cap',
      align: 'right',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className="flex justify-end">{amount_format(record?.price_end)}</div>
              }
              </>
            )
    },
    {
      title: <div className='cursor-pointer' title='Net Profit Latest Quarter'>Price Change <span className="text-xs text-gray-500">Rs</span></div>,
      dataIndex: 'price_change',
      key: 'price_change',
      align: 'right',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className={`${Number(record.price_change).toFixed(2) >= 0 ? 'text-green-600' : 'text-red-600'} text-right`}>{Number(record?.price_change)}</div>
              }
              </>
            )
    },
    {
            title: 'Change',
            dataIndex: 'change',
            key: 'id',
            align: 'right',
            width: 100,
            render: (text, record) => (                
                <>
                {data &&
                <div className={`${Number(record.percent_change).toFixed(2) >= 0 ? 'text-green-600' : 'text-red-600'} text-right`}>{Number(record.percent_change).toFixed(2)}%</div>
                }
                </>
            ),
        },
    {
      title: <div className='cursor-pointer' title='Sales Latest Quarter'>Volume </div>,
      dataIndex: 'total_volume',
      key: 'total_volume',
      align: 'right',
      width: 100,
      render:(name,record) =>(
              <>
              {data &&
              <div className="text-right">{compactIN(record?.total_volume)}</div>
              }
              </>
            )
    },
    
  
];

    const modifiedData = insertHeaderEvery(data || [], columns, 10);

    function insertHeaderEvery(result, columns, interval = 20) {
    const updated = [];

    result.forEach((row, index) => {
        // Insert header row before row number (multiple of interval)
        if (index % interval === 0 && index !== 0) {
        updated.push({ ...columns.reduce((acc, col) => {
            acc[col.dataIndex] = col.title;
            return acc;
        }, {}), _isHeader: true });
        }
        updated.push(row);
    });
    
    return updated;
    }

    const onPagination = (current) => {
        //console.log("current Page",current);
        props.onPagination(current);
    }
    const onPageSize = (value) => {
        props.onPageSize(value)
    }

    return (
        <>
            {paginatorInfo &&<div className="mt-5 text-sm text-gray-500">
                  {paginatorInfo?.total} results found: Showing page {paginatorInfo?.currentPage} of {totalPages}
                </div>}
            <div className="my-6 overflow-hidden rounded shadow">
            <Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : data}
                scroll={{x:900}}
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            </div>
            {paginatorInfo?.total > paginatorInfo?.perPage &&
            <div className="w-full flex justify-start mb-5">
                {!!paginatorInfo?.total && ( 
                <div className="w-full flex items-left justify-between flex-wrap gap-5">
                    <div>
                    <Pagination
                    total={paginatorInfo.total}
                    current={paginatorInfo.currentPage}
                    pageSize={paginatorInfo.perPage}
                    onChange={onPagination}
                    showSizeChanger={false}
                    className="flex-wrap"
                    />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="px-5 text-sm text-gray-500">Results Per Page</div>
                        <Select
                            value={pageSize}
                            onChange={onPageSize}
                            options={[
                                { value: 10, label: "10 rows" },
                                { value: 25, label: "25 rows" },
                                { value: 50, label: "50 rows" },
                                { value: 100, label: "100 rows" },
                                
                            ]}
                            style={{ width: 130 }}
                        />
                    </div>
                </div>
                )} 
            </div>
            }
        </>    
    )
}

export default StockActionTable;